import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projet-professionnel-diagnostics-form',
  templateUrl: './projet-professionnel-diagnostics-form.component.html',
  styleUrls: ['./projet-professionnel-diagnostics-form.component.scss']
})
export class ProjetProfessionnelDiagnosticsFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
